import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import * as PR from "../../prime-modules/index";
import { getAllAffiliates, getCountriesList, getReceiversCount, getNotifcations, archiveNotification, unarchiveNotification } from "../../services/api";
import AdminFooter from "../layout/admin-footer";
import AdminHeader from "../layout/admin-header";
import "../users/Users.scss"; // CSS
import "./pn.scss"; // CSS
import { useSelector, useDispatch } from 'react-redux';
import { globalConfig } from "../../GlobalConfig";
import { useFormik } from "formik";
import * as Yup from 'yup';
import * as utils from '../../utils';
import NotificationModal from "./notification-modal";
import { PERMISSIONS, hasPermission } from "../../utils/permissions";
const PushNotifications = () => {
    const dispatch = useDispatch();
    const adminData = useSelector(state => state.adminAuth.adminSessionData);
    const headers = useMemo(() => {
        return { sessionid: adminData.sessionId };
    }, [adminData.sessionId]);
    const [users, setUsers] = useState([]);
    const toast = useRef();
    const [loading, setLoading] = useState(true);
    const [pageCount] = useState(globalConfig.pageCount);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(pageCount + 1);
    const [last, setLast] = useState(true);
    const [paging, setPaging] = useState(false);
    const filterTypeRef = useRef(null);
    const [affiliateNames, setAffiliateNames] = useState([])
    const [filterByOptions] = useState([
        { label: "All", value: "ALL" },
        { label: "Affiliate", value: "AFFILIATE", permission: PERMISSIONS.VIEW_AFFILIATES },
        { label: "Region", value: "REGION" },
        { label: "Country", value: "COUNTRY" },
        { label: "Customer Email", value: "EMAIL" },
    ])
    const filteredFilterByOptions = useMemo(() => {
        return filterByOptions.filter(option => !option.permission || hasPermission(adminData.permission, option.permission));
    }, [filterByOptions, adminData.permission]);
    const [filterOpen, setFilterOpen] = useState(false);
    const [visible, setVisible] = useState(false);
    const [uniqueRegions, setUniqueRegions] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [searchRequest, setSearchRequest] = useState({});
    const [userCount, setUserCount] = useState(0);
    const [selectedFilterValues, setSelectedFilterValues] = useState([]);
    const [sortOrder, setSortOrder] = useState("desc");
    const [invalidEmails, setInvalidEmails] = useState([]);
    const [showArchived, setShowArchived] = useState(false);

    const toggleFilter = () => setFilterOpen(!filterOpen);
    const getAllAffiliateUsers = useCallback(async () => {
        if (!hasPermission(adminData.permission, PERMISSIONS.VIEW_AFFILIATES)) return;
        setLoading(true);
        getAllAffiliates(headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                const list = response.data || [];
                const affiliateOptions = list
                    .map(item => ({ label: item.name, value: item.id }))
                    .filter(Boolean) // removes null, undefined, empty string
                    .sort((a, b) => a.label.localeCompare(b.label));
                setAffiliateNames(affiliateOptions);
            } else {
                setAffiliateNames([])
                const error = response.error;
                toast.current?.show({ severity: error.severity, summary: 'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
            }
            setLoading(false);
        });
    }, [headers, dispatch, adminData.permission])

    useEffect(() => {
        const handleCountriesResponse = (response) => {
            if (response.result === "SUCCESS") {
                const countriesData = response.data || [];
                if (countriesData.length > 0) {
                    const countriesList = countriesData.map((data) => ({
                        ...data,
                        name: data?.name?.split('(')[0].trim(),
                    }));
                    const localCountriesList = countriesList?.filter(c => c?.geogType !== "Regional")?.sort((a, b) => a.name.localeCompare(b.name));
                    setAllCountries(localCountriesList);
                    const regionalList = countriesList?.filter(c => c?.geogType === "Regional").sort((a, b) => a.name.localeCompare(b.name));
                    setUniqueRegions(regionalList);
                }
            }
        };
        getCountriesList(headers, dispatch, handleCountriesResponse);
    }, [dispatch, headers]);


    const getNotificationsHandler = useCallback(async (sorting) => {
        setLoading(true);
        const obj = {
            offset: offset,
            limit: limit,
            sortField: "completedAt",
            sortOrder: sorting ? sorting : "desc",
            archived: showArchived
        };
        getNotifcations(obj, headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                const list = response.data;
                const result = list !== null ? list.slice(0, pageCount) : [];
                if (result.length > 0) {
                    setLast(list.length <= pageCount);
                    setUsers(result);
                    setPaging(true);
                } else {
                    setUsers([]);
                    setLast(true);
                    setPaging(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No records found' });
                }
            } else {
                setUsers([]);
                setLast(true);
                setPaging(false);
                const error = response.error;
                toast.current?.show({ severity: error?.severity || 'error', summary: 'Error', detail: error?.errorMsg ? error.errorMsg : error?.summary })
            }
            setLoading(false);
        })
    }, [offset, limit, headers, dispatch, pageCount, showArchived])

    useEffect(() => {
        getNotificationsHandler()
    }, [getNotificationsHandler])

    const paginate = (currentPage) => {
        setPaging(false);
        setPage(currentPage);
        const offsetVal = (currentPage - 1) * pageCount;
        const limitVal = pageCount + 1;
        setOffset(offsetVal);
        setLimit(limitVal);
    };

    const [initialValues] = React.useState({
        searchFilterType: "AFFILIATE",
        affiliateValue: [],
        regionValue: [],
        countryValue: [],
        email: [],
    })
    const validationSchema = Yup.object().shape({
        searchFilterType: Yup.string().required("Filter type is required").trim(),

        affiliateValue: Yup.array().when("searchFilterType", {
            is: "AFFILIATE",
            then: Yup.array()
                .min(1, "Please select at least one affiliate")
                .required("Affiliate is required"),
            otherwise: Yup.array().nullable()
        }),

        regionValue: Yup.array().when("searchFilterType", {
            is: "REGION",
            then: Yup.array()
                .min(1, "Please select at least one region")
                .required("Region is required"),
            otherwise: Yup.array().nullable()
        }),

        countryValue: Yup.array().when("searchFilterType", {
            is: "COUNTRY",
            then: Yup.array()
                .min(1, "Please select at least one country")
                .required("Country is required"),
            otherwise: Yup.array().nullable()
        }),

        email: Yup.array().when("searchFilterType", {
            is: "EMAIL",
            then: Yup.array()
                .min(1, "Please enter at least one email")
                .max(200, "You can enter up to 200 emails only")
                .test("valid-emails", "One or more emails are invalid", function (emails) {
                    if (!emails) return true;
                    const isValid = emails.every(email => Yup.string().email().isValidSync(email));
                    return isValid;
                }),
            otherwise: Yup.array().nullable()
        }),
    });
    const resetUserForm = () => {
        formik.resetForm();
        setSearchRequest({})
        setPage(1);
        setOffset(0);
        setLimit(pageCount + 1);
        setUserCount(0);
        setInvalidEmails([]);
    }
    const getReceiversHandler = (request) => {
        setInvalidEmails([]);
        getReceiversCount(request, headers, dispatch, response => {
            setUserCount(0);
            if (response.result === 'SUCCESS') {
                const usersCount = response.data?.usersCount;
                if (usersCount > 0) {
                    // setVisible(true);
                    setUserCount(usersCount);
                } else {
                    // setVisible(false)
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No recipients found' });
                }
            } else {
                // setVisible(false)
                const error = response.error;
                if (error.errorMsg && error.errorMsg.includes("The following emails were not found in the database")) {
                    const emailsStr = error.errorMsg.split(":")[1];
                    if (emailsStr) {
                        const failedEmails = emailsStr.split(",").map(e => e.trim());
                        setInvalidEmails(failedEmails);
                    }
                }
                toast.current?.show({ severity: error?.severity || 'error', summary: 'Error', detail: error?.errorMsg ? error.errorMsg : error?.summary })
            }
            setLoading(false);
        })

    }
    const getSelectedFilterValue = (values) => {
        switch (values.searchFilterType) {
            case "AFFILIATE":
                return values.affiliateValue || [];
            case "REGION":
                return values.regionValue || [];
            case "COUNTRY":
                return values.countryValue || [];
            case "EMAIL":
                const emailRequest = values?.email?.map(e => e?.toLowerCase())
                return emailRequest || [];
            default:
                return [];
        }
    };
    const handleSubmit = (formData) => {
        const formValues = utils.trimFormData(formData);
        const request = {
            values: getSelectedFilterValue(formValues),
            filterBy: formValues.searchFilterType
        }
        setSearchRequest(request);
        getReceiversHandler(request);
        setPage(1);
        setOffset(0);
        setLimit(pageCount + 1);
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: handleSubmit
    })
    useEffect(() => {
        if (visible && formik.values.searchFilterType === "AFFILIATE" && affiliateNames.length === 0) {
            getAllAffiliateUsers();
        }
    }, [visible, formik.values.searchFilterType, affiliateNames.length, getAllAffiliateUsers]);

    const showMinimumDigits = (number) => {
        return number < 10 ? `0${number}` : number;
    }

    const recipientsBodyTemplate = (rowData) => {
        return (
            <div className="column-data"><b className="mr-1">{rowData?.totalRecipients}</b>(<span style={{ color: "green" }}>Sent:{showMinimumDigits(rowData?.successCount)}</span>, <span style={{ color: "red" }}>Failed:{showMinimumDigits(rowData?.failureCount)}</span>) </div>
        );
    }
    const sentOnBodyTemplate = (rowData) => utils.dateTimeFormat(rowData.completedAt);

    const onArchiveChange = (rowData, e) => {
        const isArchived = e.value;
        const apiCall = isArchived ? archiveNotification : unarchiveNotification;

        apiCall(rowData.id, headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: `Notification ${isArchived ? 'archived' : 'unarchived'} successfully` });
                getNotificationsHandler(sortOrder);
            } else {
                const error = response.error;
                toast.current?.show({ severity: error?.severity || 'error', summary: 'Error', detail: error?.errorMsg ? error.errorMsg : error?.summary })
            }
        });
    }

    const archiveBodyTemplate = (rowData) => {
        // If rowData.archived is explicit, use it. Otherwise fallback to showArchived (if we are in archive mode, items are archived).
        const isChecked = rowData.archived !== undefined ? rowData.archived : showArchived;
        return (
            <div className="flex justify-content-start">
                <PR.InputSwitch
                    checked={isChecked}
                    onChange={(e) => onArchiveChange(rowData, e)}
                    tooltip={isChecked ? "Click to Unarchive notification" : "Click to Archive notification"}
                    tooltipOptions={{ position: 'top' }}
                    disabled={!hasPermission(adminData.permission, PERMISSIONS.MANAGE_PUSH_NOTIFICATIONS)}
                />
            </div>
        );
    }


    const filterTypeBodyTemplate = (rowData) => {
        let filterValues = rowData?.filterValues
        if (rowData?.filterType === "COUNTRY" || rowData?.filterType === "AFFILIATE") {
            filterValues = filterValues
                ?.map(v => rowData?.filterValueNames[v])
                ?.filter(v => typeof v === "string");
        }

        return (
            <div >
                {rowData?.filterType}
                {filterValues?.length > 0 && (
                    <i className="pi pi-info-circle ml-2 filtervalues-info-icon" onClick={(e) => {
                        setSelectedFilterValues(filterValues);
                        filterTypeRef.current.toggle(e);
                    }} />
                )}
            </div>
        );
    }

    const sentOnHeader = () => {
        const sorting = sortOrder === "desc" ? "asc" : "desc";
        return (
            <div
                className="senton"
                onClick={() => {
                    setSortOrder(sorting);
                    getNotificationsHandler(sorting);
                }}
            >
                Completed at{" "}
                {
                    <i
                        className={
                            sortOrder === "desc"
                                ? "pi pi-sort-amount-down "
                                : "pi pi-sort-amount-up"
                        }
                    />
                }{" "}
            </div>
        );
    };
    return (
        <>
            <div className="main">
                <div className="layout-sidebar">
                    <AdminHeader />
                </div>
                <PR.OverlayPanel ref={filterTypeRef} >
                    <div className="filtervalues_tooltip">{selectedFilterValues?.join(`,\n`)} </div>
                </PR.OverlayPanel>
                <div className="layout-content-wrapper">
                    <section className="admin-userlist-section admin-users-section">
                        <div className="grid grid-nogutter">
                            <div className="col-12">
                                <div className="heading-sec notifications-filter">
                                    <div className="flex align-items-center justify-content-between left">
                                        <div className="flex align-items-center justify-content-between width-full">
                                            <h2>Marketing Push Notifications</h2>
                                        </div>
                                        <div className="right-section flex align-items-center gap-2">
                                            <div className="flex align-items-center gap-2 mr-3">
                                                <PR.Checkbox inputId="showArchived" onChange={e => {
                                                    setShowArchived(e.checked);
                                                    setOffset(0);
                                                    setPage(1);
                                                    setLimit(pageCount + 1);
                                                }} checked={showArchived} />
                                                <label htmlFor="showArchived" className="cursor-pointer">Show Archived</label>
                                            </div>
                                            <div className="last">
                                                {hasPermission(adminData.permission, PERMISSIONS.MANAGE_PUSH_NOTIFICATIONS) && (
                                                    <PR.Button label="Send Notification" className="exportBtn" icon="pi pi-bell" iconPos="left" onClick={() => setVisible(true)} />
                                                )}
                                                <PR.Button text className="filter-toggle-button" onClick={toggleFilter}>
                                                    <i className={`pi ${filterOpen ? "pi-filter-slash" : "pi-filter-fill"}`}></i>
                                                </PR.Button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="users-data-table price-adjustment plan-selection card">
                            <PR.DataTable value={users} loading={loading} className="price-adjustment-table notifications-table" paginator={false} emptyMessage={<span className="text-gray-500">No results found</span>}  >
                                <PR.Column header="Title" field="title" />
                                <PR.Column header="Message" field="body" style={{ width: "30%" }} />
                                <PR.Column header="Type" body={filterTypeBodyTemplate} />
                                <PR.Column header="No. of Recipients" body={recipientsBodyTemplate} />
                                {/* <PR.Column header="Status" field="status" /> */}
                                <PR.Column header="Archive" body={archiveBodyTemplate} style={{ width: '10%' }} />

                                <PR.Column header={sentOnHeader} body={sentOnBodyTemplate} />
                            </PR.DataTable>
                        </div>
                        {users.length > 0 ? (
                            <div className="pagination">
                                <button
                                    type="button"
                                    onClick={() => paginate(page - 1)}
                                    className={paging ? page <= 1 ? "disabled" : "pagination-button" : "disabled"}
                                >
                                    {globalConfig.pagination_Previous}
                                </button>
                                <span className="active"> {page} </span>
                                <button
                                    type="button"
                                    onClick={() => paginate(page + 1)}
                                    className={paging ? last ? "disabled" : "pagination-button" : "disabled"}
                                >
                                    {globalConfig.pagination_Next}
                                </button>
                            </div>
                        ) : (
                            <></>
                        )}
                        <PR.Toast ref={toast} position='top-right' />

                    </section>
                    <AdminFooter />
                </div>
                <NotificationModal
                    visible={visible}
                    searchRequest={searchRequest}
                    userCount={userCount}
                    setUserCount={setUserCount}
                    onClose={() => setVisible(false)}
                    formik={formik}
                    filterOpen={filterOpen}
                    filterByOptions={filteredFilterByOptions}
                    affiliateNames={affiliateNames}
                    uniqueRegions={uniqueRegions}
                    allCountries={allCountries}
                    resetUserForm={resetUserForm}
                    getNotificationsHandler={getNotificationsHandler}
                    invalidEmails={invalidEmails}
                    setInvalidEmails={setInvalidEmails}
                />
            </div>
        </>
    );
};

export default PushNotifications;

